import type { CrmDataProvider } from "../types";
import { ATTACHMENTS_BUCKET } from "../commons/attachments";
import { createStorageUrlSigner } from "./signedStorageUrls";
import { getSupabaseClient } from "./supabase";

/** Signs the attachment URLs of any value read from Supabase. */
export const signStorageUrls = createStorageUrlSigner(ATTACHMENTS_BUCKET, () =>
  getSupabaseClient().storage.from(ATTACHMENTS_BUCKET),
);

/**
 * Every record the app reads (and gets back from a create or an update)
 * carries signed attachment URLs, so files of the private bucket open.
 */
export const withSignedStorageUrls = (
  dataProvider: CrmDataProvider,
): CrmDataProvider =>
  ({
    ...dataProvider,
    getList: async (resource, params) => {
      const result = await dataProvider.getList(resource, params);
      return { ...result, data: await signStorageUrls(result.data) };
    },
    getManyReference: async (resource, params) => {
      const result = await dataProvider.getManyReference(resource, params);
      return { ...result, data: await signStorageUrls(result.data) };
    },
    getMany: async (resource, params) => {
      const result = await dataProvider.getMany(resource, params);
      return { ...result, data: await signStorageUrls(result.data) };
    },
    getOne: async (resource, params) => {
      const result = await dataProvider.getOne(resource, params);
      return { ...result, data: await signStorageUrls(result.data) };
    },
    create: async (resource, params) => {
      const result = await dataProvider.create(resource, params);
      return { ...result, data: await signStorageUrls(result.data) };
    },
    update: async (resource, params) => {
      const result = await dataProvider.update(resource, params);
      return { ...result, data: await signStorageUrls(result.data) };
    },
    getConfiguration: async () =>
      signStorageUrls(await dataProvider.getConfiguration()),
  }) as CrmDataProvider;
